import { useTranslations } from "next-intl";
import Link from "@components/core/Link";
import Image from "@components/core/Image";

function SubscriptionCanceled() {
  const t = useTranslations("accounts");

  return (
    <div
      data-testid="manage-subscription-canceled-section"
      className="manage-subscription-card"
    >
      <div className="manage-subscription-card-content">
        <div className="p-3 d-flex flex-column align-items-center">
          <h5 className="text-center mb-0">
            {t("manage_subscription.cancelation.canceled.title")}
          </h5>

          <div
            className="my-5"
            style={{ width: "128px" }}
          >
            <Image
              src="handbagHappyNeon"
              alt={t("manage_subscription.cancelation.alt_happy")}
              className="w-100"
            />
          </div>

          <p className="text-center mb-0">
            {t("manage_subscription.cancelation.canceled.description")}
          </p>
        </div>

        <div className="p-3 d-flex justify-content-center border-top">
          <Link
            href="/je-commence"
            className="link-primary"
            noUnderline
          >
            {t("manage_subscription.cancelation.canceled.restart_now")}
          </Link>
        </div>
      </div>
    </div>
  );
}

export default SubscriptionCanceled;
